import { render, staticRenderFns } from "./review-response.vue?vue&type=template&id=3d168830"
import script from "./review-response.vue?vue&type=script&lang=js"
export * from "./review-response.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports